<template>
	<div class="signout-callback-container">
		<div class="callback-box">
			<div v-if="loading" class="loading-content">
				<i class="el-icon-loading loading-icon"></i>
				<h2 class="loading-title">正在登出...</h2>
				<p class="loading-text">{{ statusText }}</p>
			</div>

			<div v-else class="success-content">
				<i class="el-icon-circle-check success-icon"></i>
				<h2 class="success-title">已成功登出</h2>
				<p class="success-text">正在跳转到首页...</p>
			</div>
		</div>
	</div>
</template>

<script>
import { signoutRedirectCallback, removeUser } from '@/utils/oidcTestConfig'

export default {
	name: 'OidcTestSignout',
	data() {
		return {
			loading: true,
			statusText: '正在清除登录信息...'
		}
	},
	created() {
		this.handleCallback()
	},
	methods: {
		async handleCallback() {
			try {
				this.statusText = '正在清除登录信息...'
				
				// 移除OIDC用户
				await removeUser()
				
				this.statusText = '正在完成登出...'
				
				// 处理登出回调
				await signoutRedirectCallback()
				
				this.loading = false
				
				// 延迟跳转到首页
				setTimeout(() => {
					this.$router.push('/Acccount/OidcTest')
				}, 1500)
			} catch (error) {
				console.error('登出回调处理失败:', error)
				this.loading = false
				setTimeout(() => {
					this.$router.push('/Acccount/OidcTest')
				}, 1500)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.signout-callback-container {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	padding: 20px;
}

.callback-box {
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
	padding: 60px 50px;
	width: 100%;
	max-width: 500px;
	text-align: center;
}

.loading-content,
.success-content {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.loading-icon,
.success-icon {
	font-size: 64px;
	margin-bottom: 20px;
}

.loading-icon {
	color: #667eea;
	animation: spin 1s linear infinite;
}

.success-icon {
	color: #67c23a;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.loading-title,
.success-title {
	font-size: 24px;
	font-weight: 600;
	margin: 0 0 15px 0;
	color: #333;
}

.loading-text,
.success-text {
	font-size: 16px;
	color: #666;
	margin: 0;
	line-height: 1.6;
}
</style>

